import { render } from "./Patchnote.vue?vue&type=template&id=5fed85ae&scoped=true&ts=true&lang=pug"
import script from "./Patchnote.vue?vue&type=script&lang=ts"
export * from "./Patchnote.vue?vue&type=script&lang=ts"

import "./Patchnote.vue?vue&type=style&index=0&id=5fed85ae&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fed85ae"]])

export default __exports__